"use client";

import { useTranslations } from "next-intl";
import type { BlogForClient } from "@/features/blog/shared/types";
import { NotFound } from "@/lib/client/components/NotFound";
import { cn, Section } from "@/ui";
import { BlogItem } from "./BlogItem";

interface BlogSectionProps {
  blogPosts: BlogForClient[];
  className?: string;
}

/**
 * BlogSection component - Masonry grid of blog posts
 * Uses CSS columns for native masonry without JavaScript libraries
 */
export const BlogSection = ({ blogPosts, className }: BlogSectionProps) => {
  const notFoundT = useTranslations("not_found");

  return (
    <Section className={cn("py-8", className)}>
      {blogPosts.length > 0 ? (
        <div
          className={cn(
            // CSS columns masonry
            "columns-1 gap-6",
            "md:columns-2",
            "lg:columns-3",
            // Add space between child elements
            "space-y-6",
          )}
        >
          {blogPosts.map((post) => (
            <BlogItem
              key={post.id}
              post={post}
            />
          ))}
        </div>
      ) : (
        <NotFound
          title={notFoundT("title")}
          description={notFoundT("subtitle")}
        />
      )}
    </Section>
  );
};
